import { render, staticRenderFns } from "./NeedOpportunities.vue?vue&type=template&id=6bd4604a&scoped=true&"
import script from "./NeedOpportunities.vue?vue&type=script&lang=js&"
export * from "./NeedOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./NeedOpportunities.vue?vue&type=style&index=0&id=6bd4604a&prod&lang=css&"
import style1 from "./NeedOpportunities.vue?vue&type=style&index=1&id=6bd4604a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4604a",
  null
  
)

export default component.exports